module.exports = __webpack_public_path__ + "static/media/sjukmat_logo.d78d4a9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sjukmat_logo.png
// module id = 118
// module chunks = 0